import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-primary-black bg-opacity-80 backdrop-blur-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2 md:py-4">
          {/* Left Links */}
          <div className="hidden md:flex items-center space-x-8 flex-1">
            <Link to="/" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Home
            </Link>
            <Link to="/restaurant" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Restaurant
            </Link>
            <Link to="/menu" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Menu
            </Link>
            <Link to="/bar" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Bar
            </Link>
          </div>

          {/* Center Logo */}
          <Link to="/" className="flex-shrink-0">
            <picture>
              <source srcSet="/logo.webp" type="image/webp" />
              <img 
                src="/logo.png" 
                alt="The Creamery" 
                className="h-14 md:h-[100px] w-auto"
                fetchPriority="high"
              />
            </picture>
          </Link>

          {/* Right Links */}
          <div className="hidden md:flex items-center space-x-8 flex-1 justify-end">
            <Link to="/snooker" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Snooker
            </Link>
            <Link to="/pool" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Pool
            </Link>
            <Link to="/contact" className="text-primary-gold hover:text-white px-3 py-2 rounded-md text-md font-medium transition-colors">
              Contact Us
            </Link>
            <Link to="/book" className="bg-primary-gold text-primary-black px-6 py-2 rounded-md text-md font-medium hover:bg-primary-black hover:text-primary-gold hover:border-primary-gold transition-all">
              Book Table
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-primary-gold hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-gold"
            >
              <span className="sr-only">Open main menu</span>
              {!isMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-primary-black bg-opacity-95 border-t border-gray-800">
            <Link to="/" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/restaurant" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Restaurant
            </Link>
            <Link to="/menu" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Menu
            </Link>
            <Link to="/bar" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Bar
            </Link>
            <Link to="/snooker" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Snooker
            </Link>
            <Link to="/pool" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Pool
            </Link>
            <Link to="/contact" className="text-primary-gold hover:text-white block px-3 py-2 rounded-md text-base font-medium" onClick={() => setIsMenuOpen(false)}>
              Contact Us
            </Link>
            <Link to="/book" className="bg-primary-gold text-primary-black block w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold" onClick={() => setIsMenuOpen(false)}>
              Book Table
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
